import Decoder, * as _ from 'jsonous'
import { err, ok } from 'resulty'

import { decodeAndGet, nullOr } from '../../utils'
import { api } from './api'

import type { User } from '../auth'

const authDecoder: Decoder<string> = _.field('access_token', _.string)

const firstNumber: Decoder<number> = new Decoder((val: unknown) => {
  if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'number') return ok(val[0])
  return err('expected non-empty number array')
})

const userDecoder: Decoder<User> = _.succeed({})
  .assign('firstName', _.field('firstName', nullOr(_.string)))
  .assign('lastName', _.field('lastName', nullOr(_.string)))
  .assign('email', _.field('email', nullOr(_.string)))
  .assign('username', _.field('username', _.string))
  .assign('code', _.field('id', _.number))
  .assign('roles', _.field('roles', _.array(_.string)))
  .assign('outlet', _.field('outletsIds', firstNumber))

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    loginByPassword: build.mutation<{ accessToken: string }, { username: string; password: string }>({
      query: (body) => ({
        url: '/auth/login_by_username',
        method: 'POST',
        body,
      }),
      transformResponse: (response: unknown) => {
        const [data, error] = decodeAndGet(authDecoder, response)
        if (error) throw new Error(error)
        return { accessToken: data! }
      },
    }),
    getMe: build.query<User, void>({
      query: () => '/users/me',
      transformResponse: (response: unknown) => {
        const [data, error] = decodeAndGet(userDecoder, response)
        if (error) throw new Error(error)
        return data!
      },
      providesTags: ['User'],
    }),
    registerPushToken: build.mutation<void, { token: string; platform: string }>({
      query: (body) => ({
        url: '/fcm/register',
        method: 'POST',
        body: {
          ...body,
          type: 'Web',
          clientApp: 'ARM',
        },
      }),
    }),
    revokePushToken: build.mutation<void, { token: string }>({
      query: (body) => ({
        url: '/fcm/revoke',
        method: 'POST',
        body,
      }),
    }),
  }),
})
